import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AcceptHeaderFactoryService {

  constructor() { }

  createHeader(value) {
    return {
      Accept: value
    };
  }
}
